import { render } from "./ModuleSettingTab.vue?vue&type=template&id=fd47bbb4"
import script from "./ModuleSettingTab.vue?vue&type=script&lang=js"
export * from "./ModuleSettingTab.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__